import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const Charging = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M9.59428 18.3484C9.10598 20.3148 9.83908 20.7222 11.1505 19.2866L16.6592 12.9569C17.9337 11.4012 17.6145 10.1514 15.779 9.83889L13.1231 9.34699C12.9679 9.31829 12.8654 9.16919 12.8942 9.01409C12.8951 9.00889 12.8962 9.00379 12.8974 8.99879L13.9195 4.78169C14.4091 2.80278 13.593 2.4444 12.3689 3.84679C10.6101 5.82999 9.27338 7.32809 8.35908 8.34119C8.04028 8.69439 7.52708 9.24569 6.81958 9.99509C5.26898 11.7157 6.08508 12.9636 7.87858 13.2761L10.4169 13.7311C10.5722 13.7589 10.6755 13.9074 10.6477 14.0627C10.6466 14.0687 10.6454 14.0746 10.6439 14.0805L9.59428 18.3484Z"/>
  </SvgIcon>
);
